var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"intro",class:_vm.$store.state.theme},[_c('h1',[_vm._v("Salabam Solutions")]),_c('p',[_vm._v("Integrate travel tech into your business. Discover online travel booking solutions for your company's HR and marketing strategies.")])])
}
var staticRenderFns = []

export { render, staticRenderFns }